export default __webpack_public_path__ + "static/media/no-discussion.7dc492d9.svg";